import React from 'react';
import PropTypes from 'prop-types';

class InfoModal extends React.PureComponent {
    constructor(props) {
        super(props);

        this.overlay = React.createRef();
    }

    overlayClickHandler(e) {
        if (e.target !== this.overlay.current) return;

        this.props.onClose();
    }

    render() {
        const {
            text,
            title,
            open,
            onClose,
            children,
        } = this.props;

        return (
            <div className="info-modal" style={{ display: (open ? 'block' : 'none') }}>
                <div
                    className="info-modal--overlay"
                    onClick={e => this.overlayClickHandler(e)}
                    onKeyDown={() => {}}
                    ref={this.overlay}
                    role="presentation"
                >
                    <div className="info-modal__container">
                        <div className="info-modal__content">
                            <h3 className="info-modal__heading">{title}</h3>
                            <div className="info-modal__text">
                                {children || text}
                            </div>
                        </div>
                        {onClose ? (
                            <button onClick={onClose} className="info-modal__close-button">
                                <span className="info-modal__close-button-text sr-only">Schließen</span>
                            </button>
                        ) : ''}
                    </div>
                </div>
            </div>
        );
    }
}

InfoModal.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    title: PropTypes.string,
};

InfoModal.defaultProps = {
    children: null,
    onClose: undefined,
    open: false,
    text: undefined,
    title: undefined,
};

export default InfoModal;



// WEBPACK FOOTER //
// ./src/frontend/components/InfoModal.jsx